var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBackwardIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#18181B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m10.586 6-5.293 5.293a1 1 0 0 0 0 1.414L10.586 18m8-12-5.293 5.293a1 1 0 0 0 0 1.414L18.586 18"
})));
export { SvgBackwardIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjU4NTggNkw1LjI5Mjg5IDExLjI5MjlDNC45MDIzNyAxMS42ODM0IDQuOTAyMzcgMTIuMzE2NiA1LjI5Mjg5IDEyLjcwNzFMMTAuNTg1OCAxOE0xOC41ODU4IDZMMTMuMjkyOSAxMS4yOTI5QzEyLjkwMjMgMTEuNjgzNCAxMi45MDIzIDEyLjMxNjYgMTMuMjkyOSAxMi43MDcxTDE4LjU4NTggMTgiIHN0cm9rZT0iIzE4MTgxQiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";